/**
 * Mapbox has a bug where it stringifies arrays and objects in feature properties.
 * See more: https://github.com/mapbox/mapbox-gl-js/issues/2434
 * This function recursively parses stringified JSON values in an object.
 */
export function parseStringifiedProperties(obj: any): any {
    if (obj === null || obj === undefined) {
        return obj;
    }

    // Handle arrays
    if (Array.isArray(obj)) {
        return obj.map(item => parseStringifiedProperties(item));
    }

    // Handle objects
    if (typeof obj === "object") {
        const parsed: any = {};
        for (const key in obj) {
            if (Object.hasOwn(obj, key)) {
                parsed[key] = parseStringifiedProperties(obj[key]);
            }
        }
        return parsed;
    }

    // Handle strings that might be JSON
    if (typeof obj === "string") {
        try {
            const parsed = JSON.parse(obj);
            // Recursively parse the parsed result in case it contains nested stringified JSON
            return parseStringifiedProperties(parsed);
        } catch {
            // Not valid JSON, return as-is
            return obj;
        }
    }

    // Return primitives as-is
    return obj;
}
